var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebar4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 0.666992V2.33366M9.00033 15.667V17.3337M3.10881 3.1086L4.28381 4.2836M13.7171 13.7169L14.8921 14.8919M0.666992 9.00033H2.33366M15.667 9.00033H17.3337M4.28381 13.7169L3.10881 14.8919M14.8921 3.1086L13.7171 4.2836M12.3337 9.00033C12.3337 10.8413 10.8413 12.3337 9.00033 12.3337C7.15938 12.3337 5.66699 10.8413 5.66699 9.00033C5.66699 7.15938 7.15938 5.66699 9.00033 5.66699C10.8413 5.66699 12.3337 7.15938 12.3337 9.00033Z",
    stroke: "white",
    strokeWidth: 0.888889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebar4);
export default __webpack_public_path__ + "static/media/sidebar-4.9106a670dd5601009ae8f059e562dc62.svg";
export { ForwardRef as ReactComponent };